import { gql } from "@apollo/client";

export const Get_Mail_Client = gql`
  query GetMailClient($emailAddress: String!) {
    mailClient(emailAddress: $emailAddress) {
      emailProvider
    }
  }
`;

export const Get_Connected_Emails = gql`
  query GetConnectedEmails(
    $skip: Int
    $take: Int
    $where: UserEmailAccountFilterInput
    $order: [UserEmailAccountSortInput!]
  ) {
    connectedEmail(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        id
        userSsoEmail
        emailAddress
        emailProvider
        status
        name
        isTracked
        isDefault
        createdOn
        modifiedOn
      }
      totalCount
    }
  }
`;

export const Get_Auth_Providers = gql`
  query GetAuthProviders($authType: AuthType!) {
    authProviderUrl(authType: $authType) {
      google
      microsoft
    }
  }
`;

export const Get_Domains = gql`
  query GetDomains(
    $skip: Int
    $take: Int
    $where: DomainFilterInput
    $order: [DomainSortInput!]
  ) {
    domain(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        id
        name
        createdOn
        isVerified
        count
        dnsRecords {
          id
          type
          host
          value
          isVerified
          domainId
          createdOn
        }
      }
      totalCount
    }
  }
`;

export const Get_Domain_Emails = gql`
  query GetDomainEmails(
    $skip: Int
    $take: Int
    $where: DomainEmailFilterInput
    $order: [DomainEmailSortInput!]
  ) {
    domainEmail(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        id
        alias
        emailAddress
        domainName
        domainId
        createdOn
      }
      totalCount
    }
  }
`;

export const Get_Reply_To_Emails = gql`
  query GetReplyToEmails(
    $skip: Int
    $take: Int
    $where: ReplyToEmailsFilterInput
    $order: [ReplyToEmailsSortInput!]
  ) {
    replyToEmail(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        id
        emailAddress
        isDefault
        domainId
        createdOn
      }
      totalCount
    }
  }
`;
